import './App.css';
import Amplify from 'aws-amplify';
import amplify_config from './config/Amplify';
import Routes from './routes';
import AppProvider from './hooks';

Amplify.configure(amplify_config);

const App = () => (
  <main className="App">
    <AppProvider>
      <Routes />
    </AppProvider>
  </main>
);

export default App;
